import React from "react";
// react plugin that creates an input with badges
import {globals,hiring_contact_form} from '../Globals/Globals'
import {useSelector, useDispatch } from 'react-redux';
import { closeModalHiringContact } from '../../redux/modalSlice'; 
import {Button, Container } from "reactstrap";
import { openModal } from "../../redux/modalSlice";
import {send_custom_emailV2} from 'datasync-mail';
import { Dialog } from "../Globals/Dialog";
import {GetFormValue3Tiers} from 'datasync-core';

// core components
import {DsDynamicForm} from "datasync-dynamic-form";
import "../../Components/Modal/Modal.css";

const HiringContactDialog = () => {
  const {hiringContactModal} = useSelector((state) => state.modal);
  const user_foreign_keys = useSelector((state) => state.auth.user_guid);
  const dispatch = useDispatch();
  const {isAdmin} = useSelector((state) => state.auth);
  const {isReadOnly} = useSelector((state) => state.modal);

  React.useEffect(() => {
    console.log("hiringContactModal -> ",hiringContactModal);
    console.log("hiringContactModal.activeObject -> ",hiringContactModal.activeObject);
    console.log("user_foreign_keys ->",user_foreign_keys);

    return function cleanup() {
      document.body.classList.remove("discover");
    };
  });

  /**
   * Prototype : broadcast_hiring_contact_message_to_staff_and_connected_user
   * @param {*} hiring_contact_form 
   * Purpose : returns all validate users emails
   */
  const broadcast_hiring_contact_message_to_staff_and_connected_user = (hiring_contact_form) => {

      if (globals.parameters.debugging){
        console.clear();
        console.log("hiring_contact_form->", hiring_contact_form);
        alert("hiring_contact_form_response caught !");
      }

      try {
          //Post chat message
          send_custom_emailV2({
              mailsync_url:globals.mailsync.url,
              from:globals.mailer.ne_pas_repondre_email,
              bcc:globals.parameters.debugging?"pmabiala@me.com":GetFormValue3Tiers(hiring_contact_form,"hiring_contact_email"),
              email:globals.mailer.admin_target_email,
              subject:"Offre/demande d'emploi sur Hotels Hub 360 !",
              hiring_contact_civility:GetFormValue3Tiers(hiring_contact_form,"hiring_contact_civility"),
              hiring_contact_last_name:GetFormValue3Tiers(hiring_contact_form,"hiring_contact_last_name"),
              hiring_contact_first_name:GetFormValue3Tiers(hiring_contact_form,"hiring_contact_first_name"),

              hiring_contract:GetFormValue3Tiers(hiring_contact_form,"hiring_contract"),
              hiring_location:GetFormValue3Tiers(hiring_contact_form,"hiring_location"),
              hiring_salary:GetFormValue3Tiers(hiring_contact_form,"hiring_salary"),
              hiring_title:GetFormValue3Tiers(hiring_contact_form,"hiring_title"),
              hiring_contact_email:GetFormValue3Tiers(hiring_contact_form,"hiring_contact_email"),
              data_guid_hiring:hiring_contact_form.data_guid,
              template:`Bonjour {{hiring_contact_civility}} {{hiring_contact_last_name}} {{hiring_contact_first_name}},<br/>
                                Vous êtes intéressé(e) par l'annonce <b>{{data_guid_hiring}}</b><br/>
                                -------------------------------<br/>
                                <b>Titre:</b>{{hiring_title}}<br/>
                                <b>Salaire:</b> {{hiring_salary}}<br/>
                                <b>Lieu:</b> {{hiring_location}}<br/>
                                <b>Type:</b> {{hiring_contract}}<br/>
                                -------------------------------<br/>
                                Nous vous contacterons sous peu à l'adresse {{hiring_contact_email}}.<br/><br/>
                                {{signature}}`,
              signature:globals.mailer.signature,
              token:"",
              onMailSent:(mail_parameter) => {
                    dispatch(closeModalHiringContact());
                    //Display confirmation message
                    Dialog({
                        title: "Succès",
                        message: `Un courriel de confirmation vous a été envoyé`
                    });
                  },
                  onMailFailed:(mail_parameter) => {
                    dispatch(closeModalHiringContact());
                    Dialog({
                        title: "Erreur",
                        message: "Erreur d'envoi d'email de confirmation"
                    });
                    console.error("broadcast_hiring_contact_message_to_staff_and_connected_user::mailing failed => ", mail_parameter)
                  }
                })
      } catch (error) {
          console.error(`broadcast_hiring_contact_message_to_staff_and_connected_user::Can't build mailing list-> ${error}`)
          //alert(`Rapportez cette erreur au webmestre :: #001 Can't build mailing list -> ${error}`)
          Dialog({
              title: "Erreur",
              message: "La création de la liste de destinataires du chat a échoué !"
          });
      }
      finally {
          //reset reassign result status
          //dispatch(revertStatus())
      }
  }

  return (
      <>
        <div className="main modal-overlay">
          <Button className="modal-top-right-close-button" onClick={()=>{dispatch(closeModalHiringContact())}}>Fermer</Button>
          <div className="dialog-container">
            <Container>
              <h1>Prise de contact</h1>
              {hiringContactModal.activeObject &&
              <h2>{hiringContactModal.activeObject.data_blob.data_tier.hiring_title}</h2>}

              <p>Vous êtes intéressé par l'annonce <b>{hiringContactModal.activeObject.data_guid}</b>
              <br/> merci de remplir confidentiellement les champs suivants <br/>
                pour être mis en contact nom prenom mail (vos coordonnées ne seront pas transmises)</p>
              
              <DsDynamicForm
                col_lg={12}
                datasync_url = {globals.datasync_service.url}
                form = {hiring_contact_form}
                company_guid = {globals.datasync.platform_company_guid}
                table_guid= {"hiring-contact"}
                //Let us update the HiringCONTACT
                onFormSubmit={broadcast_hiring_contact_message_to_staff_and_connected_user}
                onFormSaved = {(saved_data) => {if (globals.parameters.save_failed_alert) dispatch(openModal({title:"Hiring should not be saved !"}))}}
                onFormUpdated = {(updated_data) => {if (globals.parameters.save_failed_alert) dispatch(openModal({title:"Hiring should not be updated !"}))}}
                onFormFailed = {() => {if (globals.parameters.save_failed_alert) dispatch(openModal({title:"Erreur de sauvegarde de l'offre d'emploi"}))}}
                clearOnSave = {true}
                clearOnUpdate = {true}
                sticky_button = {true}
                custom_button_handler = {() => {dispatch(closeModalHiringContact())}}
                custom_button_caption = {"Fermer"}
                //---
                datasync_object = {hiringContactModal.activeObject}
                data_blob = {hiringContactModal.activeObject?hiringContactModal.activeObject.data_blob:null}
                show_hidden = {isAdmin}
                foreign_keys = {hiringContactModal.activeObject==null?{"user_guid":user_foreign_keys}:null}
                read_only = {isReadOnly}
              />
            </Container>
          </div>
        </div>
      </>
    );
  }

export default HiringContactDialog;